import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import IEslTemplateItem from '../../../models/esl/eslTemplateElement';
import { EEslTemplateElementMovementMode } from '../../../models/enums/eslTemplateElementMovementMode';
import { theme } from '../../../styles/themes/mainTheme';

interface IMovementZoneOverlayProps {
  element: IEslTemplateItem;
  templateWidth: number;
  templateHeight: number;
}

const MovementZoneOverlay = ({ element, templateWidth, templateHeight }: IMovementZoneOverlayProps) => {
  const { t } = useTranslation(['eslTemplate']);

  const mode = element.movementMode ?? EEslTemplateElementMovementMode.None;
  const margin = element.movementMargin ?? 0;
  if (mode === EEslTemplateElementMovementMode.None || margin <= 0) return null;

  const movesHorizontally = mode === EEslTemplateElementMovementMode.Horizontal || mode === EEslTemplateElementMovementMode.Random;
  const movesVertically = mode === EEslTemplateElementMovementMode.Vertical || mode === EEslTemplateElementMovementMode.Random;

  const left = movesHorizontally ? element.position.left - margin : element.position.left;
  const top = movesVertically ? element.position.top - margin : element.position.top;
  const width = element.dimensions.width + (movesHorizontally ? margin * 2 : 0);
  const height = element.dimensions.height + (movesVertically ? margin * 2 : 0);

  const hasOverflow = left < 0 || top < 0 || left + width > templateWidth || top + height > templateHeight;
  const zoneColor = hasOverflow ? theme.palette.error.main : theme.palette.primary.main;

  return (
    <Box
      sx={{
        position: 'absolute',
        left,
        top,
        width,
        height,
        border: `1.5px dashed ${zoneColor}`,
        backgroundColor: `${zoneColor}1f`,
        pointerEvents: 'none',
        zIndex: 2000,
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        padding: '2px 4px',
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: zoneColor,
          fontSize: 10,
          fontWeight: 600,
          lineHeight: 1,
          backgroundColor: 'rgba(255, 255, 255, 0.85)',
          padding: '1px 3px',
          borderRadius: 0.5,
        }}
      >
        {t('eslTemplate:templateEditor.canvas.movementZoneLabel', { margin })}
      </Typography>
    </Box>
  );
};

export default MovementZoneOverlay;
